import { render, staticRenderFns } from "./stakeIntroduction.vue?vue&type=template&id=5dba0bdd&"
import script from "./stakeIntroduction.vue?vue&type=script&lang=js&"
export * from "./stakeIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./stakeIntroduction.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports